module.exports = __webpack_public_path__ + "img/2254661-83-9.813fcb97.png";